/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Verified_RefreshingInputs */

const en_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain verified! Refreshing...`)
};

const es_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Dominio verificado! Actualizando...`)
};

const fr_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine vérifié ! Actualisation...`)
};

const de_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain verifiziert! Aktualisierung...`)
};

const ja_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドメインが検証されました！更新中...`)
};

const zh_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`域名已验证！正在刷新...`)
};

const ar_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم التحقق من النطاق! جاري التحديث...`)
};

const id_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain terverifikasi! Menyegarkan...`)
};

const it_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio verificato! Aggiornamento...`)
};

const ru_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Домен подтвержден! Обновление...`)
};

const pt_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio verificado! Atualizando...`)
};

const ko_domain_verified_refreshing = /** @type {(inputs: Domain_Verified_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도메인 확인 완료! 새로 고치는 중...`)
};

/**
* | output |
* | --- |
* | "Domain verified! Refreshing..." |
*
* @param {Domain_Verified_RefreshingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_verified_refreshing = /** @type {((inputs?: Domain_Verified_RefreshingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Verified_RefreshingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_verified_refreshing(inputs)
	if (locale === "es") return es_domain_verified_refreshing(inputs)
	if (locale === "fr") return fr_domain_verified_refreshing(inputs)
	if (locale === "de") return de_domain_verified_refreshing(inputs)
	if (locale === "ja") return ja_domain_verified_refreshing(inputs)
	if (locale === "zh") return zh_domain_verified_refreshing(inputs)
	if (locale === "ar") return ar_domain_verified_refreshing(inputs)
	if (locale === "id") return id_domain_verified_refreshing(inputs)
	if (locale === "it") return it_domain_verified_refreshing(inputs)
	if (locale === "ru") return ru_domain_verified_refreshing(inputs)
	if (locale === "pt") return pt_domain_verified_refreshing(inputs)
	return ko_domain_verified_refreshing(inputs)
});